import { Api } from '@/services/Api';

export default {
  /*  1. Get all data */
  getSpeechTherapysByCriteria(body = { keyword: '' }) {
    return Api().post('/SpeechTherapyService/GetSpeechTherapyServiceByCriteria', body);
  },
  /*  2. Get one column */
  getSpeechTherapy(id) {
    return Api().get(`/SpeechTherapyService/${id}`);
  },
  /*  3. Create one column */
  saveSpeechTherapy(body) {
    return Api().post(`/SpeechTherapyService`, body);
  },
  /*  4. Delete one or more columns */
  deleteSpeechTherapy(speechTherapyService) {
    return Api().post(`/SpeechTherapyService/DeleteSpeechTherapyService`, speechTherapyService);
  },
  /*  5. post one or more columns */
  postSpeechTherapy(speechTherapyService) {
    return Api().post(`/DiagonisisInformation/PostSpeechTherapyService`, speechTherapyService);
    },
    startWF(body) {
        return Api().post(`/SpeechTherapyService/StartWF`, body);
    }
};
